import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

import Palette from '#/styles/Palette'

export const BROWSER_ICON_SIZE = 20

export const SplitContainer = styled(Box)({
  '@media (min-width: 900px)': {
    flexDirection: 'row',
    paddingBottom: 0,
  },
  'backgroundColor': '#fff',
  'display': 'flex',
  'flexDirection': 'column',
  'maxHeight': '100vh',
  'minHeight': '100vh',
  'overflowY': 'auto',
  'paddingBottom': '100px',
})

export const Sidebar = styled(Box)({
  '@media (min-width: 900px)': {
    display: 'flex',
    width: '30%',
  },
  'alignItems': 'center',
  'display': 'none',
  'flexDirection': 'column',
  'justifyContent': 'center',
  'padding': 48,
})

export const Content = styled(Box)({
  '@media (min-width: 900px)': {
    padding: 72,
  },
  'alignItems': 'flex-start',
  'display': 'flex',
  'flex': 1,
  'flexDirection': 'column',
  'gap': 16,
  'justifyContent': 'center',
  'maxWidth': '100ch',
  'padding': 40,
})

export const Eyebrow = styled(Typography)({
  color: Palette.green.primary[600],
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: 0.5,
  textTransform: 'uppercase',
})

export const Title = styled(Typography)({
  color: Palette.gray.dark[900],
  fontSize: 32,
  fontWeight: 700,
})

export const Message = styled(Typography)({
  color: Palette.gray.self[700],
  fontSize: 16,
})

export const ButtonsRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
  marginTop: 8,
})
